import React from 'react';
import { useInView } from '../hooks/useInView';
import '../styles/animations.css';

const AnimatedSection = ({ children, animation = 'fade-up', delay = 0 }) => {
  const [ref, isInView] = useInView({ threshold: 0.1 });

  return (
    <div
      ref={ref}
      className={`${isInView ? animation : ''} ${delay ? `delay-${delay}` : ''}`}
      style={{ opacity: 0 }}
    >
      {children}
    </div>
  );
};

export default AnimatedSection;